import { render, staticRenderFns } from "./AnexosSuc.vue?vue&type=template&id=b037439a&scoped=true&"
import script from "./AnexosSuc.vue?vue&type=script&lang=js&"
export * from "./AnexosSuc.vue?vue&type=script&lang=js&"
import style0 from "./AnexosSuc.vue?vue&type=style&index=0&id=b037439a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b037439a",
  null
  
)

export default component.exports